import React, { Component } from "react";
import ReactDOM from "react-dom";
import axios from "axios";
import TransferRights from "./TransferRights";
import ChangeEmail from "./ChangeEmail";
import AuthDoc2Sign from "./AuthDoc2Sign";
import AuthVenvers from "./AuthVenvers";
import { LangContext } from "../LangContext.jsx";
import PaymentInformation from "./PaymentInformation.jsx";
import HistoryPayments from "./HistoryPayments.jsx";
import CompanyUpdateRequestsHistory from "./CompanyUpdateRequestsHistory.jsx";
import TwoFactorAuth from "./TwoFactorAuth";
class AccountForm extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        const logo_default = "";
        const debugPermissions = new URLSearchParams(window.location.search).get('debug_permissions') === '1';

        this.state = {
            subscription: "",
            debugPermissions,
            accountType: {
                account_type_id: "1",
                description: "Free",
                start_date: "",
                expiration_date: "",
            },
            userName: "",
            userEmail: "",
            fiscalName: "",
            status_transfer: "",
            is_transfer: "",
            id: "",
            owner: "",
            name: "",
            country: 1,
            estado: "",
            person_type: "",
            address1: "",
            userId: "",
            address2: "",
            address3: "",
            zipcode: "",
            peopleId: "",
            municipality_id: "",
            municipio: {},
            municipio_colombia: "",
            state_brazil: "",
            municipio_brazil: "",
            rfc: "",
            rfcValidation: {
                isValid: true,
                message: "",
            },
            infoData: {
                rfc: "",
                fiscal_name: "",
            },
            estadosList: [],
            municipiosList: [],
            password_actual: "",
            nuevo_password: "",
            confirmar_nuevo_password: "",
            upload_logo: "",
            logo_path: logo_default,
            state_colombia: '',
            internalId:'',
            custom_municipality:'',
            custom_city:'',
            storage:'',
            dossiers:'',
            users:'', 
            state_colombia: "",
            internalId: "",
            custom_municipality: "",
            custom_city: "",
            personVenvers: [],
            teamPersons: [],
            sourcePersonId: null,
            targetPersonIds: [],
            sourceDossiers: [],
            selectedDossierIds: [],
            importStep: 1,
            isImportLoading: false,
            isImportingTemplates: false,
            conflictQueue: [],
            conflictIndex: 0,
            precheckTargets: [],
            pendingImportDossierIds: [],
            templateNameDecisions: [],
            frequencyDecisions: [],
            importResult: null,
            dossierSearch: '',
            dossierPage: 1,
        };
        
        this.handleChangeInput = this.handleChangeInput.bind(this);
        this.handleChangeImage = this.handleChangeImage.bind(this);
    }

    async getEstados(getEstados, country) {
        if (getEstados) {
            const lista = await axios.get("api/states?country=" + country);
            this.setState(
                {
                    estadosList: lista.data,
                },
                function () {
                    window.unblockUI();
                }
            );
        }
    }

    async getMuncipios(estado_id, getEstados = true) {
        const { lang } = this.context;
        window.blockUI(lang.get("messages.procesando"));
        const lista = await axios.get("api/municipalities?state=" + estado_id);
        this.setState(
            {
                municipiosList: lista.data,
            },
            function () {
                if (!getEstados) {
                    window.unblockUI();
                    // Set first minicipio id when change state
                    this.setState({
                        municipality_id: this.state?.municipiosList[0].id,
                    });
                }
                this.getEstados(getEstados, this.state.country);
            }
        );
    }

    async getUser() {
        const userInfo = await axios.get(`/api/account`);
        if (userInfo.status == 200) {
            const {
                id,
                is_transfer,
                accountType,
                userName,
                userEmail,
                userId,
                name,
                person_type,
                rfc,
                fiscal_name,
                address1,
                address2,
                address3,
                zipcode,
                municipality_id,
                municipio,
                logo_path,
                country_id,
                state_colombia,
                municipio_colombia,
                state_brazil,
                municipio_brazil,
                role,
                owner,
                internal_id,
                custom_municipality,
                custom_city,
                subscription,
                person_venvers,
            } = userInfo.data;
            console.log(userInfo.data)
            this.setState({ country: country_id });
            this.setState({ subscription: subscription });
            this.setState({ custom_municipality: custom_municipality });
            this.setState({ custom_city: custom_city }); 
            this.setState({ internalId: internal_id });
            this.setState({ userName: userName });
            this.setState({ userEmail: userEmail });
            this.setState({ fiscalName: fiscal_name });
            this.setState({ rfc: rfc });
            this.setState({ owner: owner });
            if (is_transfer == true) {
                this.setState({
                    status_transfer: "! en espera de confirmación",
                });
            }
            this.setState({ state_colombia: state_colombia });
            this.setState({ municipio_colombia: municipio_colombia });
            this.setState({ state_brazil: state_brazil });
            this.setState({ municipio_brazil: municipio_brazil });
            this.setState({ peopleId: id });
            this.setState({ userId: userId });
            this.setState({ personVenvers: person_venvers || [] });
            this.setState(
                {
                    id: id,
                    name: name,
                    person_type: person_type,
                    address1: address1,
                    address2: address2,
                    address3: address3,
                    zipcode: zipcode,
                    municipality_id: municipality_id,
                    municipio: municipio,
                    logo_path: logo_path,
                    infoData: {
                        rfc: rfc,
                        fiscal_name: fiscal_name,
                        role: role,
                    },
                },
                function () {
                    if (municipio != null) {
                        this.getMuncipios(municipio.state_id);
                    } else {
                        this.getMuncipios();
                    }
                }
            );
            if (this.state.country != 4) {
                this.setState({ estado: municipio.state_id });
            }

            try {
                const { data: teamPersons } = await axios.get('/api/account/team-persons');
                this.setState({ teamPersons: teamPersons || [] });
            } catch (e) {
                this.setState({ teamPersons: [] });
            }
        }
    }
    getPersonUsage = () => {
        axios.get("/api/usage").then((res) => {
            console.log(res.data.storage);
            this.setState((prevState) => ({
                storage: {
                    ...prevState.storage,
                    usage: res.data.storage,
                },
            }));
            this.setState((prevState) => ({
                dossiers: {
                    ...prevState.dossiers,
                    usage: res.data.dossiers,
                },
            }));
            this.setState((prevState) => ({
                users: {
                    ...prevState.users,
                    usage: res.data.users,
                },
            }));
        });
    };
    async handleChangeInput(ev) {
        const { name, value } = ev.target;

        // Mantener el comportamiento especial para el campo 'estado'
        if (name === "estado") {
            this.setState({ [name]: value, municipiosList: [] });
            this.getMuncipios(value, false);
        } else {
            // Actualizar el estado con el nuevo valor
            await this.setState({ [name]: value });

            // Función para validar el RFC
            const validateRFC = async (rfcValue, personTypeValue) => {
                if (this.state.country === 1 && rfcValue) {
                    try {
                        const res = await axios.post("/api/isvalid-rfc", {
                            rfc: rfcValue,
                            isInvitation: false,
                            moral: personTypeValue === "Moral",
                            country: 1,
                            personType: personTypeValue || "Física",
                        });
                        this.setState({ rfcValidation: res.data });
                    } catch (err) {
                        this.setState({
                            rfcValidation: {
                                isValid: false,
                                message: "Error validando RFC",
                            },
                        });
                    }
                }
            };

            // Validar RFC cuando se modifica el campo RFC
            if (name === "rfc") {
                await validateRFC(value, this.state.person_type);
            }

            // Validar RFC cuando se cambia el tipo de persona
            if (name === "person_type" && this.state.rfc) {
                await validateRFC(this.state.rfc, value);
            }
        }
    }

    async componentDidMount() {  
        await this.getUser();
        
        // Form user data
        let fv;
        if (this.state.country == 2) {
            fv = FormValidation.formValidation(KTUtil.getById("frm"), {
                fields: {
                    name: {
                        validators: {
                            notEmpty: {
                                message: "Nombre requerido",
                            },
                            stringLength: {
                                min: 4,
                                max: 200,
                                message:
                                    "El nombre debe tener una longitud mínima de 4",
                            },
                        },
                    },
                    address1: {
                        validators: {
                            notEmpty: {
                                message: "Dirección requerida",
                            },
                            stringLength: {
                                min: 4,
                                max: 200,
                                message:
                                    "La dirección debe tener una longitud mínima de 6",
                            },
                        },
                    },
                    zipcode: {
                        validators: {
                            notEmpty: {
                                message: "Código Postal requerido",
                            },
                            stringLength: {
                                min: 4,
                                max: 200,
                                message:
                                    "El código postal debe tener una longitud mínima de 4",
                            },
                        },
                    },
                },
                plugins: {
                    trigger: new FormValidation.plugins.Trigger(),
                    bootstrap: new FormValidation.plugins.Bootstrap({
                        eleInvalidClass: "",
                        eleValidClass: "",
                    }),
                },
            });
        } else if(this.state.country == 3){ 
            fv = FormValidation.formValidation(KTUtil.getById("frm"), {
                fields: {
                    name: {
                        validators: {
                            notEmpty: {
                                message: "Nombre requerido",
                            },
                            stringLength: {
                                min: 4,
                                max: 200,
                                message:
                                    "El nombre debe tener una longitud mínima de 4",
                            },
                        },
                    },
                    address1: {
                        validators: {
                            notEmpty: {
                                message: "Dirección requerida",
                            },
                            stringLength: {
                                min: 4,
                                max: 200,
                                message:
                                    "La dirección debe tener una longitud mínima de 6",
                            },
                        },
                    },
                    zipcode: {
                        validators: {
                            notEmpty: {
                                message: "Código Postal requerido",
                            },
                            stringLength: {
                                min: 4,
                                max: 200,
                                message:
                                    "El código postal debe tener una longitud mínima de 4",
                            },
                        },
                    },
                },
                plugins: {
                    trigger: new FormValidation.plugins.Trigger(),
                    bootstrap: new FormValidation.plugins.Bootstrap({
                        eleInvalidClass: "",
                        eleValidClass: "",
                    }),
                },
            });
        } else if (this.state.country == 1) {
            fv = FormValidation.formValidation(KTUtil.getById("frm"), {
                fields: {
                    name: {
                        validators: {
                            notEmpty: {
                                message: "Nombre requerido",
                            },
                            stringLength: {
                                min: 4,
                                max: 200,
                                message:
                                    "El nombre debe tener una longitud mínima de 4",
                            },
                        },
                    },
                    address1: {
                        validators: {
                            notEmpty: {
                                message: "Dirección requerida",
                            },
                            stringLength: {
                                min: 4,
                                max: 200,
                                message:
                                    "La dirección debe tener una longitud mínima de 6",
                            },
                        },
                    },
                    zipcode: {
                        validators: {
                            notEmpty: {
                                message: "Código Postal requerido",
                            },
                            stringLength: {
                                min: 4,
                                max: 200,
                                message:
                                    "El código postal debe tener una longitud mínima de 4",
                            },
                        },
                    },
                    estado: {
                        validators: {
                            notEmpty: {
                                message: "Estado requerido",
                            },
                        },
                    },
                    municipality_id: {
                        validators: {
                            notEmpty: {
                                message: "Municipio requerido",
                            },
                        },
                    },
                },
                plugins: {
                    trigger: new FormValidation.plugins.Trigger(),
                    bootstrap: new FormValidation.plugins.Bootstrap({
                        eleInvalidClass: "",
                        eleValidClass: "",
                    }),
                },
            });
        } else if (this.state.country == 4) {
            fv = FormValidation.formValidation(KTUtil.getById("frm"), {
                fields: {
                    name: {
                        validators: {
                            notEmpty: {
                                message: "Nombre requerido",
                            },
                            stringLength: {
                                min: 4,
                                max: 200,
                                message:
                                    "El nombre debe tener una longitud mínima de 4",
                            },
                        },
                    },
                    address1: {
                        validators: {
                            notEmpty: {
                                message: "Dirección requerida",
                            },
                            stringLength: {
                                min: 4,
                                max: 200,
                                message:
                                    "La dirección debe tener una longitud mínima de 6",
                            },
                        },
                    },
                    zipcode: {
                        validators: {
                            notEmpty: {
                                message: "Código Postal requerido",
                            },
                            stringLength: {
                                min: 4,
                                max: 200,
                                message:
                                    "El código postal debe tener una longitud mínima de 4",
                            },
                        },
                    },
                    custom_city: {
                        validators: {
                            notEmpty: {
                                message: "Estado requerido",
                            },
                        },
                    },
                    custom_municipality: {
                        validators: {
                            notEmpty: {
                                message: "Municipio requerido",
                            },
                        },
                    },
                },
                plugins: {
                    trigger: new FormValidation.plugins.Trigger(),
                    bootstrap: new FormValidation.plugins.Bootstrap({
                        eleInvalidClass: "",
                        eleValidClass: "",
                    }),
                },
            });
        } 
        const btnSaveInfo = document.getElementById("btnSaveInfo");
        btnSaveInfo.addEventListener("click", () => {
            fv.validate().then((status) => {
                if (status == "Valid") {
                    this.updateInfo();
                } else {
                    this.showValidations();
                }
            });
        });

        // Form password user

        const fvPassword = FormValidation.formValidation(
            KTUtil.getById("frmPassword"),
            {
                fields: {
                    password_actual: {
                        validators: {
                            notEmpty: {
                                message: "Contraseña actual requerido",
                            },
                            stringLength: {
                                min: 6,
                                max: 200,
                                message:
                                    "La contraseña actual debe tener una longitud mínima de 6",
                            },
                        },
                    },
                    nuevo_password: {
                        validators: {
                            notEmpty: {
                                message: "Nueva contraseña requerida",
                            },
                            stringLength: {
                                min: 6,
                                max: 200,
                                message:
                                    "La nueva contraseña debe tener una longitud mínima de 6",
                            },
                        },
                    },
                    confirmar_nuevo_password: {
                        validators: {
                            notEmpty: {
                                message: "Validar contraseña requerida",
                            },
                            stringLength: {
                                min: 6,
                                max: 200,
                                message:
                                    "Validar contraseña debe tener una longitud mínima de 6",
                            },
                            identical: {
                                compare: function () {
                                    return KTUtil.getById("nuevo_password")
                                        .value;
                                },
                                message:
                                    "La contraseña y su validación deben de ser iguales",
                            },
                        },
                    },
                },
                plugins: {
                    trigger: new FormValidation.plugins.Trigger(),
                    bootstrap: new FormValidation.plugins.Bootstrap({
                        eleInvalidClass: "",
                        eleValidClass: "",
                    }),
                },
            }
        );

        const btnSavePassword = document.getElementById("btnSavePassword");
        btnSavePassword.addEventListener("click", () => {
            fvPassword.validate().then((status) => {
                if (status == "Valid") {
                    this.updatePasswords();
                } else {
                    this.showValidations();
                }
            });
        });

        const fvUserName = FormValidation.formValidation(
            KTUtil.getById("frmUserName"),
            {
                fields: {
                    userName: {
                        validators: {
                            notEmpty: {
                                message: "Nombre requeridos",
                            },
                            stringLength: {
                                min: 4,
                                max: 100,
                                message:
                                    "El nombre debe tener una longitud mínima de 4",
                            },
                        },
                    },
                },
                plugins: {
                    trigger: new FormValidation.plugins.Trigger(),
                    bootstrap: new FormValidation.plugins.Bootstrap({
                        eleInvalidClass: "",
                        eleValidClass: "",
                    }),
                },
            }
        );

        const btnSaveUserName = document.getElementById("btnSaveUserName");
        btnSaveUserName.addEventListener("click", () => {
            console.log("btnSaveUserName clicked");
            fvUserName.validate().then((status) => {
                if (status == "Valid") {
                    this.updateUserName();
                }
            });
        });

        const storage = {
            limitation:
                this.props.subscription.billing_plan.limitations[1]
                    .limitation_value,
            usage: 0,
        };
        this.setState({ storage: storage });
        const dossiers = {
            limitation:
                this.props.subscription.billing_plan.limitations[0]
                    .limitation_value,
            usage: 0,
        };
        this.setState({ dossiers: dossiers }); 
        const users = {
            limitation:
                this.props.subscription.billing_plan.limitations[2]
                    .limitation_value,
            usage: 0,
        };
        this.setState({ users: users });
        this.getPersonUsage();  
    }

    async updateInfo() {
        const { lang } = this.context;
        window.blockUI(lang.get("messages.procesando"));

        const params = JSON.stringify({
            name: this.state.name,
            country: this.state.country,
            person_type: this.state.person_type,
            address1: this.state.address1,
            zipcode: this.state.zipcode,
            municipality_id: this.state.municipality_id,
            municipio_colombia: this.state.municipio_colombia,
            state_colombia: this.state.state_colombia,
            municipio_brazil: this.state.municipio_brazil,
            state_brazil: this.state.state_brazil,
            fiscal_name: this.state.fiscalName,
            rfc: this.state.rfc,
            custom_city: this.state.custom_city,
            custom_municipality: this.state.custom_municipality,
        });

        await axios
            .post("/api/account/update", params, {
                headers: {
                    "content-type": "application/json",
                },
            })
            .then((response) => {
                window.unblockUI();
                let data = response.data;
                if (data.error) {
                    let msg = this.paseErrors(data);
                    this.showError(msg);
                } else {
                    this.showSuccess(lang.get("messages.datos_actualizados"));
                }
            })
            .catch((error) => {
                window.unblockUI();
                let msg = this.paseErrors(error.response.data);
                this.showError(msg);
            });
    }
    async updateUserName() {
        const { lang } = this.context;
        window.blockUI(lang.get("messages.procesando"));
        const params = JSON.stringify({
            name: this.state.userName,
        });

        await axios
            .post("/api/account/update-user", params, {
                headers: {
                    "content-type": "application/json",
                },
            })
            .then((response) => {
                window.unblockUI();
                Swal.fire({
                    html: lang.get("messages.nombre_de_usuario_actualizado"),
                    icon: "success",
                    buttonsStyling: false,
                    confirmButtonText: lang.get("messages.aceptar"),
                    customClass: {
                        confirmButton: "btn font-weight-bold btn-primary",
                    },
                }).then(function (result) {
                    location.reload();
                });
            });
    }
    async updatePasswords() {
        const { lang } = this.context;
        window.blockUI(lang.get("messages.procesando"));

        const params = JSON.stringify({
            password_actual: this.state.password_actual,
            nuevo_password: this.state.nuevo_password,
            confirmar_nuevo_password: this.state.confirmar_nuevo_password,
        });

        await axios
            .post("/api/account/update-password", params, {
                headers: {
                    "content-type": "application/json",
                },
            })
            .then((response) => {
                window.unblockUI();
                let data = response.data;
                if (data.error) {
                    let msg = this.paseErrors(data);
                    this.showError(msg);
                } else {
                    this.showSuccess(
                        lang.get("messages.contrasena_actualizada"),
                        true
                    );
                }
            })
            .catch((error) => {
                window.unblockUI();
                let msg = this.paseErrors(error.response.data);
                this.showError(msg);
            });
    }

    async uploadLogo() {
        const { lang } = this.context;
        window.blockUI(lang.get("messages.procesando"));

        const formData = new FormData();

        formData.append(
            "logo",
            this.state.upload_logo,
            this.state.upload_logo.name
        );

        axios
            .post("/api/account/update-logo", formData)
            .then((response) => {
                window.unblockUI();
                this.showSuccess("Logo actualizado", true);
                this.setState({
                    logo_path: response.data.path,
                });
            })
            .catch((error) => {
                window.unblockUI();
                let msg = this.paseErrors(error.response.data);
                this.showError(msg);
            });
    }

    paseErrors(errors) {
        let msg = "";
        Object.keys(errors.errors).map((key, i) => {
            msg = msg + errors.errors[key][0] + " ";
        });
        return msg;
    }

    handleChangeImage(e) {
        this.setState(
            {
                upload_logo: e.target.files[0],
            },
            this.uploadLogo
        );
    }

    showError(msg) {
        const { lang } = this.context;
        swal.fire({
            text: msg,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: lang.get("messages.aceptar"),
            customClass: {
                confirmButton: "btn font-weight-bold btn-primary",
            },
        });
    }

    showSuccess(msg, clear = false) {
        const { lang } = this.context;
        swal.fire({
            text: msg,
            icon: "success",
            buttonsStyling: false,
            confirmButtonText: lang.get("messages.aceptar"),
            customClass: {
                confirmButton: "btn font-weight-bold btn-primary",
            },
        }).then((result) => {
            if (clear) {
                this.setState({
                    password_actual: "",
                    nuevo_password: "",
                    confirmar_nuevo_password: "",
                });
            }
        });
    }

    showValidations() {
        const { lang } = this.context;
        swal.fire({
            text: lang.get(
                "messages.por_favor_valida_que_los_datos_sean_correctos"
            ),
            icon: "warning",
            buttonsStyling: false,
            confirmButtonText: "Continuar",
            customClass: {
                confirmButton: "btn font-weight-bold btn-danger",
            },
        });
    }

    openImportTemplatesModal = async () => {
        this.setState({
            isImportLoading: true,
            importStep: 1,
            sourcePersonId: null,
            targetPersonIds: [],
            sourceDossiers: [],
            selectedDossierIds: [],
            importResult: null,
        });

        try {
            const { data } = await axios.get('/api/account/team-persons');
            const teamPersons = data || [];
            const defaultSourceId = Number(this.state.peopleId) || Number(this.state.sourcePersonId) || null;
            const hasDefaultInTeam = defaultSourceId && teamPersons.some((p) => Number(p.id) === defaultSourceId);
            const fallbackSourceId = teamPersons.length > 0 ? Number(teamPersons[0].id) : null;

            this.setState({
                teamPersons,
                sourcePersonId: hasDefaultInTeam ? defaultSourceId : fallbackSourceId,
            });
            $('#importDossiersModal').modal('show');
        } catch (error) {
            this.showError('No fue posible cargar las empresas del team');
        } finally {
            this.setState({ isImportLoading: false });
        }
    }

    getFilteredTargetPersons = () => {
        const sourcePersonId = Number(this.state.sourcePersonId);
        const sourcePerson = (this.state.teamPersons || []).find((p) => Number(p.id) === sourcePersonId);
        const sourceTeamId = sourcePerson ? Number(sourcePerson.team_id) : null;

        return (this.state.teamPersons || []).filter((person) => {
            if (Number(person.id) === sourcePersonId) {
                return false;
            }

            if (!sourceTeamId) {
                return false;
            }

            return Number(person.team_id) === sourceTeamId;
        });
    }

    loadSourceDossiers = async () => {
        if (!this.state.sourcePersonId) {
            this.showError('Selecciona una empresa origen');
            return;
        }

        this.setState({ isImportLoading: true });

        try {
            const { data } = await axios.get(`/api/account/team-persons/${this.state.sourcePersonId}/templates`);
            this.setState({
                sourceDossiers: data || [],
                selectedDossierIds: [],
                dossierSearch: '',
                dossierPage: 1,
                importStep: 2,
            });
        } catch (error) {
            this.showError('No fue posible cargar las plantillas del origen');
        } finally {
            this.setState({ isImportLoading: false });
        }
    }

    goToTemplatesStep = () => {
        const allowedTargetIds = new Set(this.getFilteredTargetPersons().map((person) => Number(person.id)));
        const cleanedTargets = (this.state.targetPersonIds || []).map((id) => Number(id)).filter((id) => allowedTargetIds.has(id));

        if (cleanedTargets.length !== this.state.targetPersonIds.length) {
            this.setState({ targetPersonIds: cleanedTargets });
        }

        if (cleanedTargets.length === 0) {
            this.showError('Selecciona al menos una empresa destino');
            return;
        }

        this.setState({ importStep: 3 });
    }

    handleTargetToggle = (personId) => {
        const id = Number(personId);
        this.setState((prevState) => {
            const exists = prevState.targetPersonIds.includes(id);
            return {
                targetPersonIds: exists
                    ? prevState.targetPersonIds.filter((item) => item !== id)
                    : [...prevState.targetPersonIds, id],
            };
        });
    }

    handleDossierToggle = (templateId) => {
        const id = Number(templateId);
        this.setState((prevState) => {
            const exists = prevState.selectedDossierIds.includes(id);
            return {
                selectedDossierIds: exists
                    ? prevState.selectedDossierIds.filter((item) => item !== id)
                    : [...prevState.selectedDossierIds, id],
            };
        });
    }

    toggleAllDossiers = () => {
        if (this.state.selectedDossierIds.length === this.state.sourceDossiers.length) {
            this.setState({ selectedDossierIds: [] });
            return;
        }
        this.setState({
            selectedDossierIds: this.state.sourceDossiers.map((template) => template.id),
        });
    }

    executeImportDossiers = async (dossierIds, templateNameDecisions = [], frequencyDecisions = []) => {
        const allowedTargetIds = new Set(this.getFilteredTargetPersons().map((person) => Number(person.id)));
        const targetPeopleIds = (this.state.targetPersonIds || []).map((id) => Number(id)).filter((id) => allowedTargetIds.has(id));

        const { data } = await axios.post('/api/account/import-templates', {
            source_people_id: this.state.sourcePersonId,
            target_people_ids: targetPeopleIds,
            dossier_ids: dossierIds,
            template_name_decisions: templateNameDecisions,
            frequency_decisions: frequencyDecisions,
        });

        this.setState({
            importStep: 5,
            importResult: {
                source_people_id: Number(this.state.sourcePersonId),
                created_dossiers: Number(data?.created_dossiers || 0),
                created_documents: Number(data?.created_documents || 0),
                reused_documents: Number(data?.reused_documents || 0),
                summary: Array.isArray(data?.summary) ? data.summary : [],
            },
            isImportingTemplates: false,
        });
    }

    buildConflictQueue = (precheckTargets, initialDossierIds) => {
        const targetMap = (this.state.teamPersons || []).reduce((acc, p) => {
            acc[Number(p.id)] = p.fiscal_name || p.name || `Empresa ${p.id}`;
            return acc;
        }, {});

        const selectedDossiers = new Set((initialDossierIds || []).map((id) => Number(id)));
        const queue = [];
        const dedup = new Set();

        (precheckTargets || []).forEach((target) => {
            const targetId = Number(target.target_people_id);
            const empresa = targetMap[targetId] || `Empresa ${targetId}`;

            (target.dossier_name_conflicts || []).forEach((conflict) => {
                if (!selectedDossiers.has(Number(conflict.source_dossier_id))) return;
                queue.push({ kind: 'dossier', target_people_id: targetId, empresa, ...conflict });
            });

            (target.template_name_conflicts || []).forEach((conflict) => {
                if (!selectedDossiers.has(Number(conflict.source_dossier_id))) return;
                const isGeneral = Number(conflict.source_type_id) === 1;
                const sameFrequency = Boolean(conflict.same_frequency_config);
                if (!isGeneral || sameFrequency) return;
                const key = `general:${targetId}:${conflict.source_document_id}`;
                if (dedup.has(key)) return;
                dedup.add(key);
                queue.push({ kind: 'general_template_diff_frequency', target_people_id: targetId, empresa, ...conflict });
            });

            (target.frequency_conflicts || []).forEach((conflict) => {
                if (!selectedDossiers.has(Number(conflict.source_dossier_id))) return;
                const key = `freq:${targetId}:${conflict.source_document_id}`;
                if (dedup.has(key)) return;
                dedup.add(key);
                queue.push({ kind: 'non_general_frequency', target_people_id: targetId, empresa, ...conflict });
            });
        });

        return queue;
    }

    importDossiers = async () => {
        if (this.state.selectedDossierIds.length === 0) {
            this.showError('Selecciona al menos una plantilla de expediente');
            return;
        }

        this.setState({ isImportingTemplates: true });

        try {
            const precheckResp = await axios.post('/api/account/import-templates/precheck', {
                source_people_id: this.state.sourcePersonId,
                target_people_ids: this.state.targetPersonIds,
                dossier_ids: this.state.selectedDossierIds,
            });

            const targets = precheckResp?.data?.targets || [];
            const conflictQueue = this.buildConflictQueue(targets, this.state.selectedDossierIds);

            if (!conflictQueue.length) {
                await this.executeImportDossiers(this.state.selectedDossierIds, [], []);
                return;
            }

            this.setState({
                importStep: 4,
                conflictQueue,
                conflictIndex: 0,
                precheckTargets: targets,
                pendingImportDossierIds: [...this.state.selectedDossierIds],
                templateNameDecisions: [],
                frequencyDecisions: [],
                isImportingTemplates: false,
            });
        } catch (error) {
            const msg = error?.response?.data?.message || 'No fue posible importar plantillas de expediente';
            this.showError(msg);
            this.setState({ isImportingTemplates: false });
        }
    }

    getConflictCompanyStatuses = () => {
        const selectedTargets = (this.state.teamPersons || [])
            .filter((person) => this.state.targetPersonIds.includes(Number(person.id)))
            .map((person) => ({
                id: Number(person.id),
                name: person.fiscal_name || person.name || `Empresa ${person.id}`,
            }));

        const currentConflict = this.state.conflictQueue[this.state.conflictIndex] || null;

        return selectedTargets.map((target) => {
            const conflictsForTarget = this.state.conflictQueue
                .map((item, idx) => ({ ...item, idx }))
                .filter((item) => Number(item.target_people_id) === target.id);

            const hasConflicts = conflictsForTarget.length > 0;
            const isCurrent = currentConflict && Number(currentConflict.target_people_id) === target.id;
            const allResolved = !hasConflicts || conflictsForTarget.every((item) => item.idx < this.state.conflictIndex);

            return {
                ...target,
                hasConflicts,
                isCurrent,
                allResolved,
            };
        });
    }

    handleConflictAnswer = async (action) => {
        const current = this.state.conflictQueue[this.state.conflictIndex];
        if (!current) return;

        let pendingImportDossierIds = [...this.state.pendingImportDossierIds];
        let templateNameDecisions = [...this.state.templateNameDecisions];
        let frequencyDecisions = [...this.state.frequencyDecisions];

        if (current.kind === 'dossier' && action === 'skip') {
            pendingImportDossierIds = pendingImportDossierIds.filter((id) => Number(id) !== Number(current.source_dossier_id));
        }

        if (current.kind === 'general_template_diff_frequency') {
            templateNameDecisions.push({
                target_people_id: Number(current.target_people_id),
                source_document_id: Number(current.source_document_id),
                action: action === 'copy' ? 'copy' : 'use',
            });
        }

        if (current.kind === 'non_general_frequency') {
            frequencyDecisions.push({
                target_people_id: Number(current.target_people_id),
                source_document_id: Number(current.source_document_id),
                action: action === 'ignore' ? 'ignore' : 'use',
            });
        }

        const nextIndex = this.state.conflictIndex + 1;

        if (nextIndex >= this.state.conflictQueue.length) {
            if (!pendingImportDossierIds.length) {
                this.showError('Se omitieron todos los expedientes. No hay nada para importar.');
                this.setState({ importStep: 3, isImportingTemplates: false });
                return;
            }

            this.setState({ isImportingTemplates: true });
            try {
                await this.executeImportDossiers(pendingImportDossierIds, templateNameDecisions, frequencyDecisions);
            } catch (error) {
                const msg = error?.response?.data?.message || 'No fue posible importar plantillas de expediente';
                this.showError(msg);
            } finally {
                this.setState({ isImportingTemplates: false });
            }

            return;
        }

        this.setState({
            conflictIndex: nextIndex,
            pendingImportDossierIds,
            templateNameDecisions,
            frequencyDecisions,
        });
    }

    render() {
        const { lang } = this.context;
        const storageUsagePercentage =
        (this.state.storage.usage / this.state.storage.limitation) * 100;
        const dossiersUsagePercentage =
        (this.state.dossiers.usage / this.state.dossiers.limitation) * 100; 
        const usersUsagePercentage =
        (this.state.users.usage / this.state.users.limitation) * 100; 
        const currentConflict = this.state.conflictQueue[this.state.conflictIndex] || null;
        const conflictCompanyStatuses = this.state.importStep === 4 ? this.getConflictCompanyStatuses() : [];
        const sourceCompanyName = (this.state.teamPersons.find((p) => Number(p.id) === Number(this.state.sourcePersonId))?.fiscal_name
            || this.state.teamPersons.find((p) => Number(p.id) === Number(this.state.sourcePersonId))?.name
            || 'Empresa Origen');
        const defaultPersonId = Number(this.state.peopleId);
        const defaultPerson = (this.state.teamPersons || []).find((p) => Number(p.id) === defaultPersonId);
        const defaultTeamId = defaultPerson ? Number(defaultPerson.team_id) : null;
        const defaultTeamCompaniesCount = defaultTeamId
            ? (this.state.teamPersons || []).filter((p) => Number(p.team_id) === defaultTeamId).length
            : 0;
        const defaultCompanyTemplatesCount = Number(defaultPerson?.dossiers_count || 0);
        const canShowReplicateTemplates = defaultCompanyTemplatesCount > 0;
        const dossierPageSize = 5;
        const filteredDossiers = (this.state.sourceDossiers || []).filter((template) =>
            (template.title || '').toLowerCase().includes((this.state.dossierSearch || '').toLowerCase())
        );
        const dossierTotalPages = Math.max(1, Math.ceil(filteredDossiers.length / dossierPageSize));
        const dossierCurrentPage = Math.min(this.state.dossierPage || 1, dossierTotalPages);
        const pagedDossiers = filteredDossiers.slice((dossierCurrentPage - 1) * dossierPageSize, dossierCurrentPage * dossierPageSize);
        const myAccountPermissions = this.props.permissions?.my_account || [];
        const canSeeConnectivityCard = myAccountPermissions.includes('all') || myAccountPermissions.includes('conectivities');
        const canShowConnectivityModules = (this.props.permissions.venvers.includes('connect') || this.props.permissions.venvers.includes('all')) || this.props.doc2sign_enabled === "true";
        const importResult = this.state.importResult || null;
        const summaryRows = Array.isArray(importResult?.summary) ? importResult.summary : [];
        const sourceCompanyLabel = (this.state.teamPersons || []).find((p) => Number(p.id) === Number(importResult?.source_people_id || this.state.sourcePersonId))?.fiscal_name
            || sourceCompanyName;

        const getDocTypeBadge = (doc) => {
            const rawType = String(doc?.type_name || doc?.document_type_name || '').toLowerCase();
            if (rawType.includes('autom') || rawType.includes('validación') || rawType.includes('validacion')) {
                return {
                    label: 'Validación Automática',
                    cls: 'badge font-weight-bolder',
                    style: { background: '#F8EFB8', color: '#EF8F00' },
                };
            }
            if (rawType.includes('fiscal')) {
                return {
                    label: 'Comprobante Fiscal',
                    cls: 'badge font-weight-bolder',
                    style: { background: '#DCE7F9', color: '#3268E8' },
                };
            }
            return {
                label: 'General',
                cls: 'badge font-weight-bolder',
                style: { background: '#D8F3EA', color: '#06C49C' },
            };
        };

        return (
            <>
                <TransferRights peopleId={this.state.peopleId} />
                <ChangeEmail
                    userId={this.state.userId}
                    fiscalName={this.state.infoData.fiscal_name}
                />

                {this.state.debugPermissions && (
                    <div className="alert alert-light-warning mb-4">
                        <div className="font-weight-bolder mb-2">DEBUG /Account - permisos de Mi cuenta</div>
                        <div><strong>Usuario:</strong> {this.state.userEmail || '-'}</div>
                        <div><strong>Empresa (peopleId):</strong> {this.state.peopleId || '-'}</div>
                        <div><strong>my_account:</strong> <code>{JSON.stringify(myAccountPermissions)}</code></div>
                    </div>
                )}

                <div className="modal fade" id="importDossiersModal" tabIndex="-1" role="dialog" aria-hidden="true">
                    <div className="modal-dialog modal-xl" role="document" style={{ maxWidth: '1000px', width: '95%' }}>
                        <div className="modal-content">
                            <div className="modal-header border-0 pb-0">
                                <div>
                                    <h5 className="modal-title card-label font-weight-bolder font-size-md text-dark-75">Copiar Plantillas de Expedientes</h5>
                                    {this.state.importStep <= 3 && (
                                        <small className="text-muted">Paso {this.state.importStep} de 3</small>
                                    )}
                                </div>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body pt-2">
                                {this.state.importStep <= 3 && (
                                    <div className="d-flex align-items-center justify-content-between mb-4 px-1">
                                        <div className="d-flex align-items-center">
                                            <div className="rounded-circle d-flex align-items-center justify-content-center font-weight-bold" style={{ width: 38, height: 38, background: this.state.importStep > 1 ? '#1BC5BD' : (this.state.importStep === 1 ? '#8950FC' : '#E4E6EF'), color: (this.state.importStep >= 1 ? '#fff' : '#8A8FA8') }}>
                                                {this.state.importStep > 1 ? '✓' : '1'}
                                            </div>
                                            <span className="ml-2 font-weight-bold" style={{ color: this.state.importStep > 1 ? '#1BC5BD' : (this.state.importStep === 1 ? '#8950FC' : '#B5B9C8') }}>Empresa Origen</span>
                                        </div>
                                        <div style={{ flex: 1, height: 2, background: this.state.importStep > 1 ? '#1BC5BD' : '#E4E6EF', margin: '0 16px' }}></div>
                                        <div className="d-flex align-items-center">
                                            <div className="rounded-circle d-flex align-items-center justify-content-center font-weight-bold" style={{ width: 38, height: 38, background: this.state.importStep > 2 ? '#1BC5BD' : (this.state.importStep === 2 ? '#8950FC' : '#E4E6EF'), color: (this.state.importStep >= 2 ? '#fff' : '#8A8FA8') }}>
                                                {this.state.importStep > 2 ? '✓' : '2'}
                                            </div>
                                            <span className="ml-2 font-weight-bold" style={{ color: this.state.importStep > 2 ? '#1BC5BD' : (this.state.importStep === 2 ? '#8950FC' : '#B5B9C8') }}>Empresas Destino</span>
                                        </div>
                                        <div style={{ flex: 1, height: 2, background: this.state.importStep > 2 ? '#1BC5BD' : '#E4E6EF', margin: '0 16px' }}></div>
                                        <div className="d-flex align-items-center">
                                            <div className="rounded-circle d-flex align-items-center justify-content-center font-weight-bold" style={{ width: 38, height: 38, background: this.state.importStep === 3 ? '#8950FC' : '#E4E6EF', color: this.state.importStep === 3 ? '#fff' : '#8A8FA8' }}>3</div>
                                            <span className="ml-2 font-weight-bold" style={{ color: this.state.importStep === 3 ? '#8950FC' : '#B5B9C8' }}>Seleccionar Plantillas</span>
                                        </div>
                                    </div>
                                )}

                                {this.state.importStep === 4 && conflictCompanyStatuses.length > 0 && (
                                    <div className="mb-4 p-3 border rounded" style={{ background: '#f8f9fc' }}>
                                        <div className="font-weight-bold mb-2">Empresas destino</div>
                                        {conflictCompanyStatuses.map((item) => {
                                            const isPurple = item.allResolved;
                                            const isGreen = !isPurple && item.isCurrent;
                                            const bg = isPurple ? '#8950FC' : (isGreen ? '#1BC5BD' : '#E4E6EF');
                                            const color = isPurple || isGreen ? '#FFFFFF' : '#3F4254';

                                            return (
                                                <div key={`conflict-company-${item.id}`} className="d-flex align-items-center justify-content-between mb-2 px-3 py-2" style={{ borderRadius: 8, background: bg, color }}>
                                                    <span>{item.name}</span>
                                                    {isGreen && <small className="font-weight-bold">Resolviendo conflictos...</small>}
                                                    {isPurple && <small className="font-weight-bold">Listo</small>}
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}

                                {this.state.isImportLoading && <p>Cargando...</p>}

                                {this.state.importStep === 1 && !this.state.isImportLoading && (
                                    <>
                                        <div className="mb-4">
                                            <h4 className="font-weight-bolder text-dark-75 mb-1">Selecciona la empresa origen</h4>
                                            <p className="text-muted mb-0">Elige la empresa desde donde deseas copiar las plantillas de documentos</p>
                                        </div>

                                        {(() => {
                                            const sourcePerson = this.state.teamPersons.find((person) => Number(person.id) === Number(this.state.sourcePersonId));
                                            if (!sourcePerson) {
                                                return <p className="text-muted">No se encontró empresa origen predeterminada.</p>;
                                            }

                                            const displayName = sourcePerson.fiscal_name || sourcePerson.name;
                                            const initials = (displayName || 'EM').split(' ').filter(Boolean).slice(0, 2).map((p) => p[0]).join('').toUpperCase();
                                            const templatesCount = sourcePerson.dossiers_count || 0;

                                            return (
                                                <div
                                                    className="w-100 text-left mb-3"
                                                    style={{
                                                        borderRadius: 12,
                                                        border: '1px solid #E4E6EF',
                                                        background: '#fff',
                                                        padding: '16px 20px',
                                                    }}
                                                >
                                                    <div className="d-flex align-items-center justify-content-between">
                                                        <div className="d-flex align-items-center">
                                                            <div className="symbol symbol-40 mr-3">
                                                                <div className="symbol-label font-weight-bolder" style={{ background: '#E4E6EF', color: '#7E8299' }}>
                                                                    {initials}
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <div className="text-dark-75 font-weight-bolder font-size-h5">{displayName}</div>
                                                                <div className="text-muted font-weight-bold font-size-lg">{templatesCount} plantillas de expedientes disponibles</div>
                                                            </div>
                                                        </div>
                                                        <div className="rounded-circle" style={{ width: 20, height: 20, border: '7px solid #8950FC' }}></div>
                                                    </div>
                                                </div>
                                            );
                                        })()}
                                    </>
                                )}

                                {this.state.importStep === 2 && (
                                    <>
                                        <div className="mb-3">
                                            <p className="mb-0 text-dark-75 font-size-lg">
                                                Puedes seleccionar una o varias empresas donde se copiarán las plantillas.
                                            </p>
                                        </div>

                                        <div
                                            className="w-100 text-left mb-3"
                                            style={{ borderRadius: 12, background: '#FFFFFF', padding: '14px 18px', border: '1px solid #E4E6EF' }}
                                        >
                                            <div className="d-flex align-items-center">
                                                <label className="checkbox checkbox-lg checkbox-square mb-0 mr-3">
                                                    <input
                                                        type="checkbox"
                                                        checked={(() => {
                                                            const targets = this.getFilteredTargetPersons().map((person) => Number(person.id));
                                                            return targets.length > 0 && targets.every((id) => this.state.targetPersonIds.includes(id));
                                                        })()}
                                                        onChange={() => {
                                                            const targets = this.getFilteredTargetPersons().map((person) => Number(person.id));
                                                            const allSelected = targets.length > 0 && targets.every((id) => this.state.targetPersonIds.includes(id));
                                                            this.setState({ targetPersonIds: allSelected ? [] : targets });
                                                        }}
                                                    />
                                                    <span></span>
                                                </label>
                                                <div className="text-dark-75 font-weight-bolder font-MD">Seleccionar todas las empresas</div>
                                            </div>
                                        </div>

                                        {this.getFilteredTargetPersons()
                                            .map((person) => {
                                                const selected = this.state.targetPersonIds.includes(Number(person.id));
                                                const displayName = person.fiscal_name || person.name;
                                                const initials = (displayName || 'EM').split(' ').filter(Boolean).slice(0, 2).map((p) => p[0]).join('').toUpperCase();
                                                return (
                                                    <div
                                                        key={`target-${person.id}`}
                                                        className="w-100 text-left mb-3"
                                                        role="button"
                                                        tabIndex={0}
                                                        onClick={() => this.handleTargetToggle(person.id)}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter' || e.key === ' ') {
                                                                e.preventDefault();
                                                                this.handleTargetToggle(person.id);
                                                            }
                                                        }}
                                                        style={{ borderRadius: 12, border: selected ? '2px solid #8950FC' : '1px solid #E4E6EF', background: '#fff', padding: '16px 20px', cursor: 'pointer' }}
                                                    >
                                                        <div className="d-flex align-items-center justify-content-between">
                                                            <div className="d-flex align-items-center">
                                                                <div className="symbol symbol-40 mr-3"><div className="symbol-label text-white font-weight-bolder bg-info">{initials}</div></div>
                                                                <div>
                                                                    <div className="text-dark-75 font-weight-bolder font-md">{displayName}</div>
                                                                    <div className="text-muted font-weight-bold font-size-lg">{person.dossiers_count || 0} plantillas de expedientes actuales</div>
                                                                </div>
                                                            </div>
                                                            <label className="checkbox checkbox-lg checkbox-square mb-0" onClick={(e) => e.stopPropagation()}>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={selected}
                                                                    onClick={(e) => e.stopPropagation()}
                                                                    onChange={(e) => {
                                                                        e.stopPropagation();
                                                                        this.handleTargetToggle(person.id);
                                                                    }}
                                                                />
                                                                <span></span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                );
                                            })}

                                        <div className="mt-3">
                                            <p className="mb-0 text-dark-75 font-weight-bolder">{this.state.targetPersonIds.length} empresas seleccionadas</p>
                                        </div>
                                    </>
                                )}

                                {this.state.importStep === 3 && (
                                    <>
                                        <div className="mt-3 alert alert-warning" style={{backgroundColor: '#FFF3CD', color: '#92400E'}}>
                                            <div className="d-flex flex-column">
                                                <div className="d-flex">
                                                <svg className="mr-4" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"> 
                                                    <path d="M18.109 15L11.4423 3.33333C11.297 3.07684 11.0862 2.86349 10.8314 2.71506C10.5767 2.56662 10.2872 2.48842 9.99234 2.48842C9.69752 2.48842 9.40797 2.56662 9.15324 2.71506C8.8985 2.86349 8.6877 3.07684 8.54234 3.33333L1.87567 15C1.72874 15.2545 1.6517 15.5433 1.65235 15.8371C1.653 16.1309 1.73132 16.4194 1.87938 16.6732C2.02744 16.927 2.23996 17.1372 2.49542 17.2824C2.75088 17.4276 3.04018 17.5026 3.33401 17.5H16.6673C16.9598 17.4997 17.2469 17.4225 17.5001 17.2761C17.7532 17.1297 17.9634 16.9192 18.1094 16.6659C18.2555 16.4126 18.3324 16.1253 18.3323 15.8329C18.3322 15.5405 18.2552 15.2532 18.109 15Z" stroke="#F59E0B" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M10 7.5V10.8333" stroke="#F59E0B" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M10 14.1667H10.0083" stroke="#F59E0B" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                                <p className="mb-2"><strong>Selecciona las plantillas a clonar</strong></p>
                                                </div>
                                                <div>
                                                    <p className="mb-0  ">
                                                    Las plantillas seleccionadas se copiarán desde {(this.state.teamPersons.find(p => Number(p.id) === Number(this.state.sourcePersonId))?.fiscal_name || this.state.teamPersons.find(p => Number(p.id) === Number(this.state.sourcePersonId))?.name || 'empresa origen')} hacia {this.state.teamPersons.filter(p => this.state.targetPersonIds.includes(Number(p.id))).map(p => p.fiscal_name || p.name).join(' y ')}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="mb-3">
                                            <input
                                                type="text"
                                                className="form-control form-control-lg form-control-solid"
                                                placeholder="Buscar plantillas..."
                                                value={this.state.dossierSearch}
                                                onChange={(e) => this.setState({ dossierSearch: e.target.value, dossierPage: 1 })}
                                            />
                                        </div>

                                        <div className="w-100 text-left mb-2" style={{ borderRadius: 12, border: '1px solid #E4E6EF', background: '#F7F8FC', padding: '14px 18px' }}>
                                            <div className="d-flex align-items-center">
                                                <label className="checkbox checkbox-lg checkbox-square mb-0 mr-3">
                                                    <input
                                                        type="checkbox"
                                                        checked={this.state.selectedDossierIds.length === this.state.sourceDossiers.length && this.state.sourceDossiers.length > 0}
                                                        onChange={this.toggleAllDossiers}
                                                    />
                                                    <span></span>
                                                </label>
                                                <div className="text-dark-75 font-weight-bolder font-md">Selecciona las plantillas de expedientes ({this.state.sourceDossiers.length})</div>
                                            </div>
                                        </div>

                                        <div className="px-4 py-2 mb-2"  >
                                            <div className="row text-muted font-weight-bolder">
                                                <div className="col-4">Nombre</div>
                                                <div className="col-3">Relación</div>
                                                <div className="col-3">Tipo</div>
                                                <div className="col-2">No de Documentos</div>
                                            </div>
                                        </div>

                                        {pagedDossiers.map((template) => {
                                            const selected = this.state.selectedDossierIds.includes(Number(template.id));
                                            return (
                                                <div key={`template-${template.id}`} className="px-4 py-3 mb-2" style={{ borderBottom: '1px solid #ECECF3' }}>
                                                    <div className="row align-items-center">
                                                        <div className="col-4 d-flex align-items-center">
                                                            <label className="checkbox checkbox-lg checkbox-square mb-0 mr-3">
                                                                <input
                                                                    type="checkbox"
                                                                    checked={selected}
                                                                    onChange={() => this.handleDossierToggle(template.id)}
                                                                />
                                                                <span></span>
                                                            </label>
                                                            <span className="text-dark-75 font-weight-bolder font-size-md">{template.title}</span>
                                                        </div>
                                                        <div className="col-3 text-muted font-weight-bold font-size-lg">{template.dossier_target_name || '-'}</div>
                                                        <div className="col-3 text-muted font-weight-bold font-size-lg">{template.dossier_type_name || '-'}</div>
                                                        <div className="col-2 text-muted font-weight-bold font-size-lg">{template.documents_count || 0}</div>
                                                    </div>
                                                </div>
                                            );
                                        })}

                                        <div className="d-flex justify-content-end align-items-center mt-2 mb-2">
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-light mr-2"
                                                disabled={dossierCurrentPage <= 1}
                                                onClick={() => this.setState({ dossierPage: Math.max(1, dossierCurrentPage - 1) })}
                                            >
                                                Anterior
                                            </button>
                                            <span className="text-muted font-weight-bold mr-2">Página {dossierCurrentPage} de {dossierTotalPages}</span>
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-light"
                                                disabled={dossierCurrentPage >= dossierTotalPages}
                                                onClick={() => this.setState({ dossierPage: Math.min(dossierTotalPages, dossierCurrentPage + 1) })}
                                            >
                                                Siguiente
                                            </button>
                                        </div>

                                        <div className="mt-3 alert alert-warning" style={{backgroundColor: '#FFF3CD', color: '#92400E'}}>
                                            <div className="d-flex flex-column">
                                                <div className="d-flex">
                                                <svg className="mr-4" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"> 
                                                    <path d="M18.109 15L11.4423 3.33333C11.297 3.07684 11.0862 2.86349 10.8314 2.71506C10.5767 2.56662 10.2872 2.48842 9.99234 2.48842C9.69752 2.48842 9.40797 2.56662 9.15324 2.71506C8.8985 2.86349 8.6877 3.07684 8.54234 3.33333L1.87567 15C1.72874 15.2545 1.6517 15.5433 1.65235 15.8371C1.653 16.1309 1.73132 16.4194 1.87938 16.6732C2.02744 16.927 2.23996 17.1372 2.49542 17.2824C2.75088 17.4276 3.04018 17.5026 3.33401 17.5H16.6673C16.9598 17.4997 17.2469 17.4225 17.5001 17.2761C17.7532 17.1297 17.9634 16.9192 18.1094 16.6659C18.2555 16.4126 18.3324 16.1253 18.3323 15.8329C18.3322 15.5405 18.2552 15.2532 18.109 15Z" stroke="#F59E0B" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M10 7.5V10.8333" stroke="#F59E0B" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M10 14.1667H10.0083" stroke="#F59E0B" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                                <p className="mb-2"><strong>{this.state.selectedDossierIds.length} plantillas de expedientes seleccionadas → Se copiarán a {this.state.targetPersonIds.length} empresas</strong></p>
                                                </div>
                                                <div>
                                                    <p className="mb-0  ">
                                                    Nota: Estas plantillas se copiarán junto con sus plantillas de documentos asignadas.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        
                                    </>
                                )}

                                {this.state.importStep === 4 && currentConflict && (
                                    <>
                                        {currentConflict.kind === 'dossier' && (
                                            <>
                                                <div className="alert alert-soft-warning mt-3 mb-3 d-flex align-items-center" role="alert">
                                                    <div>
                                                        <span className="flaticon2-warning mr-4 icon-2x"></span>
                                                    </div>
                                                    <div>
                                                        <div className="font-size-md font-weight-bold" style={{ color: '#E67E22' }}>Favor de tomar acción.</div>
                                                        <div className="font-size-md font-weight-bolder" style={{ color: '#E67E22' }}>
                                                            Conflicto en plantilla de expediente <strong>{currentConflict.source_dossier_title || '-'}</strong>
                                                        </div>
                                                        <div className="font-size-md font-weight-bolder" style={{ color: '#E67E22' }}>
                                                            No es posible copiar la plantilla de expediente, debido a que ya existe una plantilla con las mismas características que la que se intenta copiar.
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="table-responsive mt-4">
                                                    <table className="table">
                                                        <thead>
                                                            <tr>
                                                                <th></th>
                                                                <th className="font-size-md font-weight-bolder text-dark-75">Origen<br/><span className="text-muted font-weight-bold">({sourceCompanyName})</span></th>
                                                                <th className="font-size-md font-weight-bolder text-dark-75">Destino<br/><span className="text-muted font-weight-bold">({currentConflict.empresa})</span></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td className="font-size-md font-weight-bolder text-muted">Plantilla de expediente</td>
                                                                <td className="font-size-md font-weight-bolder text-dark-75">{currentConflict.source_dossier_title}</td>
                                                                <td className="font-size-md font-weight-bolder text-dark-75">{currentConflict.existing_dossier_title || currentConflict.source_dossier_title}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>

                                                <p className="font-size-md font-weight-bolder text-dark-75">¿Deseas que utilicemos la plantilla existente para que tu expediente conserve la misma estructura que en la empresa de origen?</p>
                                            </>
                                        )}

                                        {currentConflict.kind === 'general_template_diff_frequency' && (
                                            <>
                                                <h6 className="font-size-md font-weight-bolder text-dark-75">Conflicto en plantilla de documento <span className="text-muted font-weight-bold">({currentConflict.source_document_title || '-'})</span></h6>
                                                <div className="font-size-md font-weight-bolder" style={{ color: '#E67E22' }}>
                                                    Plantilla de Expediente {currentConflict.source_dossier_title || '-'}
                                                </div>
                                                <p className="text-muted font-weight-bold mb-4">Favor de tomar acción</p>
                                                <p className="font-size-md font-weight-bolder text-dark-75">Ya existe una plantilla con el mismo nombre pero diferente frecuencia.</p>
                                            </>
                                        )}

                                        {currentConflict.kind === 'non_general_frequency' && (
                                            <>
                                                <div className="alert alert-soft-warning mt-3 mb-3 d-flex align-items-center" role="alert">
                                                    <div>
                                                        <span className="flaticon2-warning mr-4 icon-2x"></span>
                                                    </div>
                                                    <div>
                                                        <div className="font-size-md font-weight-bold" style={{ color: '#E67E22' }}>Favor de tomar acción.</div>
                                                        <div className="font-size-md font-weight-bolder" style={{ color: '#E67E22' }}>
                                                            Conflicto en plantilla de expediente <strong>{currentConflict.source_dossier_title || '-'}</strong> con la plantilla de documento <strong>{currentConflict.source_document_title || '-'}</strong>
                                                        </div>
                                                        <div className="font-size-md font-weight-bolder" style={{ color: '#E67E22' }}>
                                                            No es posible copiar la plantilla de documento, debido a que ya existe una plantilla con las mismas características que la que se intenta copiar.
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="table-responsive mt-4">
                                                    <table className="table">
                                                        <thead>
                                                            <tr>
                                                                <th></th>
                                                                <th className="font-size-md font-weight-bolder text-dark-75">Plantilla Origen<br/><span className="text-muted font-weight-bold">({sourceCompanyName})</span></th>
                                                                <th className="font-size-md font-weight-bolder text-dark-75">Plantilla Existente<br/><span className="text-muted font-weight-bold">({currentConflict.empresa})</span></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td className="font-size-md font-weight-bolder text-muted">Nombre</td>
                                                                <td className="font-size-md font-weight-bolder text-dark-75">{currentConflict.source_document_title}</td>
                                                                <td className="font-size-md font-weight-bolder text-dark-75">{currentConflict.existing_document_title}</td>
                                                            </tr>
                                                            <tr>
                                                                <td className="font-size-md font-weight-bolder text-muted">Recurrencia</td>
                                                                <td className="font-size-md font-weight-bolder text-dark-75">{currentConflict.source_period || '-'}</td>
                                                                <td className="font-size-md font-weight-bolder text-dark-75">{currentConflict.existing_period || '-'}</td>
                                                            </tr>
                                                            <tr>
                                                                <td className="font-size-md font-weight-bolder text-muted">Última modificación</td>
                                                                <td className="font-size-md font-weight-bolder text-dark-75">{currentConflict.source_updated_at || '-'}</td>
                                                                <td className="font-size-md font-weight-bolder text-dark-75">{currentConflict.existing_updated_at || '-'}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>

                                                <p className="font-size-md font-weight-bolder text-dark-75">
                                                    ¿Deseas que utilicemos la plantilla de documento existente para que tu expediente conserve la misma estructura que en la empresa de origen?
                                                </p>
                                            </>
                                        )}
                                    </>
                                )}
                                {this.state.importStep === 5 && importResult && (
                                    <>
                                        <div className="text-center mb-6">
                                            <div className="mx-auto mb-4 d-flex align-items-center justify-content-center" style={{ width: 96, height: 96 }}>
                                                <svg width="96" height="96" viewBox="0 0 96 96" aria-hidden="true">
                                                    <circle cx="48" cy="48" r="44" fill="none" stroke="#A5DC86" strokeWidth="4" />
                                                    <path d="M30 49 L43 62 L67 35" fill="none" stroke="#A5DC86" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </div>
                                            <h4 className="font-weight-bolder text-dark-75 mb-2">Copia de plantillas de expedientes completada</h4>
                                            <p className="text-muted mb-3">Las plantillas de expediente y de documentos seleccionadas fueron copiadas correctamente.</p>
                                            <div className="d-flex justify-content-center align-items-center">
                                                <span className="mr-2 text-muted">Empresa Origen:</span>
                                                <span className="badge badge-primary mr-2">{(sourceCompanyLabel || '').substring(0, 2).toUpperCase() || 'OR'}</span>
                                                <span className="font-weight-bolder text-dark-75">{sourceCompanyLabel}</span>
                                            </div>
                                        </div>

                                        <div className="table-responsive" style={{ border: '1px solid #E4E6EF', borderRadius: 8, maxHeight: 320, overflowY: 'auto' }}>
                                            <table className="table table-bordered mb-0">
                                                <thead style={{ background: '#F3F6F9' }}>
                                                    <tr>
                                                        <th className="font-size-md font-weight-bolder text-dark-75">Empresa Destino</th>
                                                        <th className="font-size-md font-weight-bolder text-dark-75">Plantilla de Expediente</th>
                                                        <th className="font-size-md font-weight-bolder text-dark-75">Plantillas de Documento</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {summaryRows.map((row, idx) => {
                                                        const targetName = row?.target_people_name || row?.target_name || 'Empresa destino';
                                                        const targetInitials = targetName
                                                            .split(' ')
                                                            .filter(Boolean)
                                                            .slice(0, 2)
                                                            .map((part) => part.charAt(0))
                                                            .join('')
                                                            .toUpperCase() || 'EM';
                                                        const docs = Array.isArray(row?.documents) ? row.documents : [];
                                                        return (
                                                            <tr key={`import-summary-${idx}`}>
                                                                <td>
                                                                    <div className="d-flex align-items-center">
                                                                        <div className="symbol symbol-20 mr-3">
                                                                            <div className="symbol-label bg-primary text-white font-weight-bolder">
                                                                                {targetInitials}
                                                                            </div>
                                                                        </div>
                                                                        <span className="font-weight-bolder text-dark-75">{targetName}</span>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div className="d-flex align-items-center">
                                                                        <i className="flaticon2-open-text-book icon-lg mr-3 text-primary"></i>
                                                                        <span className="font-weight-bolder text-dark-75">{row?.dossier_title || '-'}</span>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    {docs.length === 0 && <span className="text-muted">Sin documentos</span>}
                                                                    {docs.map((doc, docIdx) => {
                                                                        const docTitle = typeof doc === 'string' ? doc : (doc?.title || '-');
                                                                        const type = getDocTypeBadge(doc);
                                                                        return (
                                                                            <div key={`import-summary-doc-${idx}-${docIdx}`} className="d-flex align-items-center justify-content-between mb-1">
                                                                                <div className="d-flex align-items-center mr-3">
                                                                                    <i className="flaticon2-files-and-folders icon-lg mr-3 text-primary"></i>
                                                                                    <span className="text-dark-75">{docTitle}</span>
                                                                                </div>
                                                                                <span className={type.cls} style={type.style}>{type.label}</span>
                                                                            </div>
                                                                        );
                                                                    })}
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    </>
                                )}
                            </div>
                            <div
                                className="modal-footer"
                                style={{ borderTop: 'none', display: 'flex', justifyContent: (this.state.importStep === 1 || this.state.importStep === 5) ? 'flex-end' : 'space-between', alignItems: 'center' }}
                            >
                                {this.state.importStep > 1 && this.state.importStep < 4 && (
                                    <button
                                        type="button"
                                        className="btn btn-light font-weight-bolder"
                                        onClick={() => this.setState({ importStep: this.state.importStep - 1 })}
                                    >
                                        ← Atrás
                                    </button>
                                )}
                                {this.state.importStep === 1 && (
                                    <button
                                        type="button"
                                        className="btn btn-primary font-weight-bolder"
                                        onClick={this.loadSourceDossiers}
                                    >
                                        Siguiente
                                    </button>
                                )}
                                {this.state.importStep === 2 && (
                                    <button
                                        type="button"
                                        className="btn btn-primary font-weight-bolder"
                                        onClick={this.goToTemplatesStep}
                                    >
                                        Siguiente
                                    </button>
                                )}
                                {this.state.importStep === 3 && (
                                    <button
                                        type="button"
                                        className="btn btn-success font-weight-bolder"
                                        onClick={this.importDossiers}
                                        disabled={this.state.isImportingTemplates}
                                    >
                                        {this.state.isImportingTemplates ? 'Importando...' : 'Copiar Plantillas de Expedientes'}
                                    </button>
                                )}
                                {this.state.importStep === 5 && (
                                    <button
                                        type="button"
                                        className="btn btn-primary font-weight-bolder"
                                        onClick={() => $('#importDossiersModal').modal('hide')}
                                    >
                                        Cerrar
                                    </button>
                                )}
                                {this.state.importStep === 4 && currentConflict && currentConflict.kind === 'dossier' && (
                                    <>
                                        <button type="button" className="btn btn-light font-weight-bolder" onClick={() => this.handleConflictAnswer('skip')}>Saltar</button>
                                        <button type="button" className="btn btn-primary font-weight-bolder" onClick={() => this.handleConflictAnswer('copy')}>Usar plantilla existente</button>
                                    </>
                                )}
                                {this.state.importStep === 4 && currentConflict && currentConflict.kind === 'general_template_diff_frequency' && (
                                    <>
                                        <button type="button" className="btn btn-light-danger" onClick={() => this.handleConflictAnswer('copy')}>Saltar</button>
                                        <button type="button" className="btn btn-primary" onClick={() => this.handleConflictAnswer('use')}>Usar plantilla existente</button>
                                    </>
                                )}
                                {this.state.importStep === 4 && currentConflict && currentConflict.kind === 'non_general_frequency' && (
                                    <>
                                        <button type="button" className="btn btn-light font-weight-bolder" onClick={() => this.handleConflictAnswer('ignore')}>Saltar</button>
                                        <button type="button" className="btn btn-primary font-weight-bolder" onClick={() => this.handleConflictAnswer('use')}>Usar plantilla existente</button>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="d-flex flex-column-fluid">

                    <div className="container">
                        <div className="card card-custom">
                            <div className="card-header py-3">
                                <div className="card-title align-items-start flex-column">
                                    <h3 className="card-label font-weight-bolder text-dark">
                                        {lang.get("messages.mis_datos")}
                                    </h3>
                                    <span className="text-muted font-weight-bold font-size-sm mt-1">
                                        Administra la Información de tú perfil
                                    </span>
                                </div>
                                <div className="card-toolbar">
                                    <button
                                        id="btnSaveUserName"
                                        className="btn btn-primary font-weight-bolder mr-2"
                                    >
                                        {lang.get("messages.guardar")}
                                    </button>
                                </div>
                            </div>
                            <form className="form" id="frmUserName">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-6">
                                            <div className="form-group mb-0">
                                                <label className="text-alert">
                                                    {lang.get(
                                                        "messages.nombre"
                                                    )}
                                                </label>
                                                <input
                                                    id="name"
                                                    name="userName"
                                                    type="text"
                                                    className="form-control form-control-lg form-control-solid"
                                                    placeholder={lang.get(
                                                        "messages.nombre_de_usuario"
                                                    )}
                                                    value={this.state.userName}
                                                    onChange={
                                                        this.handleChangeInput
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className="form-group mb-0">
                                                <label className="text-alert">
                                                    {lang.get(
                                                        "messages.correo_electronico"
                                                    )}
                                                    {(this.props.permissions.user_actions.includes(
                                                        "transfer_account"
                                                    ) ||
                                                        this.props.permissions.user_actions.includes(
                                                            "all"
                                                        )) && (
                                                        <a
                                                            className="text-primary underline"
                                                            data-toggle="modal"
                                                            data-target="#changeEmail"
                                                        >
                                                            {" "}
                                                            {lang.get(
                                                                "messages.actualizar_correo"
                                                            )}{" "}
                                                        </a>
                                                    )}
                                                </label>
                                                <label
                                                    className="labeldomain"
                                                    dataDomain={
                                                        this.state
                                                            .status_transfer
                                                    }
                                                >
                                                    <input
                                                        name="confirmar_nuevo_password"
                                                        type="text"
                                                        className="form-control form-control-lg form-control-solid"
                                                        placeholder={lang.get(
                                                            "messages.verificar_contrasena"
                                                        )}
                                                        value={
                                                            this.state.userEmail
                                                        }
                                                        readOnly
                                                    />
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <br />
                        <div className="card card-custom">
                            <div className="card-header py-3">
                                <div className="card-title align-items-start flex-column">
                                    <h3 className="card-label font-weight-bolder text-dark">
                                        {lang.get(
                                            "messages.cambiar_contrasena"
                                        )}
                                    </h3>
                                    <span className="text-muted font-weight-bold font-size-sm mt-1">
                                        Actualiza la contraseña de acceso a tu cuenta
                                    </span>
                                </div>
                                <div className="card-toolbar">
                                    <button
                                        id="btnSavePassword"
                                        className="btn btn-primary font-weight-bolder mr-2"
                                    >
                                        {lang.get("messages.guardar")}
                                    </button>
                                </div>
                            </div>
                            <form className="form" id="frmPassword">
                                <div className="card-body">
                                    <div className="form-group">
                                        <label className="text-alert">
                                            {lang.get(
                                                "messages.contrasena_actual"
                                            )}
                                        </label>
                                        <input
                                            name="password_actual"
                                            type="password"
                                            className="form-control form-control-lg form-control-solid mb-2"
                                            placeholder={lang.get(
                                                "messages.contrasena_actual"
                                            )}
                                            value={this.state.password_actual}
                                            onChange={this.handleChangeInput}
                                        />
                                    </div>
                                    <div className="row">
                                        <div className="col-6">
                                            <div className="form-group mb-0">
                                                <label className="text-alert">
                                                    {lang.get(
                                                        "messages.nueva_contrasena"
                                                    )}
                                                </label>
                                                <input
                                                    id="nuevo_password"
                                                    name="nuevo_password"
                                                    type="password"
                                                    className="form-control form-control-lg form-control-solid"
                                                    placeholder={lang.get(
                                                        "messages.nueva_contrasena"
                                                    )}
                                                    value={
                                                        this.state
                                                            .nuevo_password
                                                    }
                                                    onChange={
                                                        this.handleChangeInput
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className="form-group mb-0">
                                                <label className="text-alert">
                                                    {lang.get(
                                                        "messages.verificar_contrasena"
                                                    )}
                                                </label>
                                                <input
                                                    name="confirmar_nuevo_password"
                                                    type="password"
                                                    className="form-control form-control-lg form-control-solid"
                                                    placeholder={lang.get(
                                                        "messages.verificar_contrasena"
                                                    )}
                                                    value={
                                                        this.state
                                                            .confirmar_nuevo_password
                                                    }
                                                    onChange={
                                                        this.handleChangeInput
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <br />
                        <div className="card card-custom">
                            <div className="card-header py-3">
                                <div className="card-title align-items-start flex-column">
                                    <h3 className="card-label font-weight-bolder text-dark">
                                        {this.state.person_type === "Natural" ||
                                        this.state.person_type === "Física"
                                            ? lang.get(
                                                  "messages.datos_fiscales"
                                              )
                                            : lang.get(
                                                  "messages.datos_de_empresa"
                                              )}
                                    </h3>
                                    <span className="text-muted font-weight-bold font-size-sm mt-1">
                                        Información general de la empresa, plan actual y consumo de servicios
                                    </span>
                                </div>
                                <div className="card-toolbar"> 
                                    <button
                                        type="reset"
                                        id="btnSaveInfo"
                                        className="btn btn-primary font-weight-bolder mr-2"
                                        onClick={this.updateInfo.bind(this)}
                                        disabled={
                                            this.state.country === 1 &&
                                            this.state.rfcValidation &&
                                            !this.state.rfcValidation.isValid
                                        }
                                    >
                                        {lang.get("messages.guardar")}
                                        </button>
                                </div>
                            </div>
                            <form className="form" id="frm">
                                <div className="card-body">
                                    <div  className="row align-items-center offcanvas-mobile"    id="kt_profile_aside" >
                                        <div className="col-md-12">
                                            <div className="card-body  card card-custom gutter-b">
                                                <div className="row">
                                                    <div className="col-md-8">
                                                                                                        <div className="d-flex gap-2 align-items-center">
                                                    <div
                                                        className="image-input image-input-outline mr-5"
                                                        id="kt_profile_avatar"
                                                        style={{
                                                            backgroundImage:
                                                                "url(assets/img/logo_default.png)",
                                                        }}
                                                    >
                                                        <div
                                                            className="image-input-wrapper"
                                                            style={{
                                                                backgroundImage:
                                                                    "url(" +
                                                                    this.state
                                                                        .logo_path +
                                                                    ")",
                                                            }}
                                                        ></div>
                                                        <label
                                                            className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                                                            data-action="change"
                                                            data-toggle="tooltip"
                                                            title=""
                                                            data-original-title="Cambiar Logo"
                                                        >
                                                            <i className="fa fa-pen icon-sm text-muted"></i>
                                                            <input
                                                                type="file"
                                                                name="upload_logo"
                                                                accept=".png, .jpg, .jpeg"
                                                                onChange={
                                                                    this
                                                                        .handleChangeImage
                                                                }
                                                            />
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <div className="d-flex align-items-center flex-wrap">
                                                            <span className="font-weight-bolder font-size-h5 text-dark-75 mr-3">
                                                                {this.state.infoData.fiscal_name}
                                                            </span>
                                                            {this.state.internalId != "" && (
                                                                <span className="badge font-weight-bolder" style={{ background: '#EEE5FF', color: '#8950FC' }}>
                                                                    {this.state.person_type}
                                                                </span>
                                                            )}
                                                        </div>

                                                        <div className="text-muted">
                                                            {this.state.infoData.rfc}
                                                        </div>

                                                        <div className="mt-2">
                                                            <div className="text-dark-50 font-weight-bolder font-size-sm">
                                                                {lang.get("messages.usuario_propietario")}: <span className="text-primary">{this.state.owner.user?.email}</span>
                                                            </div>

                                                            {(this.props.permissions.my_account.includes("make_owner") || this.props.permissions.my_account.includes("all")) && (
                                                                <div className="text-dark-50 font-weight-bolder font-size-sm">
                                                                    <span className="mr-2">→ ¿Quieres cambiar el usuario propietario?</span>
                                                                    <span className="text-primary" data-toggle="modal" data-target="#modal">
                                                                        Cambiar propietario
                                                                    </span>
                                                                </div>
                                                            )}

                                                            {(this.props.permissions.my_account.includes("import_templates") || this.props.permissions.my_account.includes("all")) && canShowReplicateTemplates && (
                                                                <div className="text-dark-50 font-weight-bolder font-size-sm">
                                                                    <span className="mr-2">→ ¿Quieres replicar la estructura de plantillas en otra compañía?</span>
                                                                    <span className="text-primary" role="button" onClick={this.openImportTemplatesModal}>
                                                                        Replicar configuración de plantillas
                                                                    </span>
                                                                    
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div> 
                                                   
                                                </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                    {(this.props.uses_legacy_billing == 0  ) &&
                                                    <>
                                                        <div>
                                                            <span className="font-weight-bolder font-size-h5 text-dark-75 text-hover-primary">
                                                                {lang.get(
                                                                    "messages.plan"
                                                                )}
                                                                :
                                                                {this.state.subscription?.billing_plan?.name}
                                                            </span>{" "}
                                                            <br></br>
                                                            <div className="text-dark-50 font-size-lg">
                                                                {lang.get(
                                                                    "messages.contratacion"
                                                                )}
                                                                :{" "}
                                                                {this.state.subscription?.current_term_starts_at ? new Date(this.state.subscription.current_term_starts_at).toISOString().split('T')[0] : ''}
                                                            </div> 
                                                                <div className="text-dark-50   font-size-lg">
                                                                    {lang.get(
                                                                        "messages.expira"
                                                                    )}
                                                                    :{" "}
                                                                    {this.state.subscription?.current_term_ends_at ? new Date(this.state.subscription.current_term_ends_at).toISOString().split('T')[0] : ''}
                                                                </div> 
                                                        </div>
                                                    </> }
                                                    </div>
                                                </div> 
                                            </div>
                                        </div> 
                                    </div>
                                    <div className="row offcanvas-mobile card-body custom-row card card-custom gutter-b">
                                        <div className="row ">
                                            <div className="col-6">
                                                <div className="form-group">
                                                    <label className="text-alert">
                                                        {this.state.person_type ===
                                                            "Natural" ||
                                                        this.state.person_type ===
                                                            "Física"
                                                            ? lang.get(
                                                                "messages.nombre_completo"
                                                            )
                                                            : lang.get(
                                                                "messages.razon_social"
                                                            )}
                                                    </label>
                                                    <input
                                                        name="fiscalName"
                                                        type="text"
                                                        className="form-control form-control-lg form-control-solid"
                                                        required
                                                        value={
                                                            this.state.fiscalName
                                                        }
                                                        onChange={
                                                            this.handleChangeInput
                                                        }
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="form-group">
                                                    <label className="text-alert">
                                                        {lang.get(
                                                            "messages.tipo_persona"
                                                        ) || "Tipo de Persona"}
                                                    </label>
                                                    <select
                                                        name="person_type"
                                                        className="form-control form-control-lg form-control-solid"
                                                        required
                                                        value={
                                                            this.state
                                                                .person_type || ""
                                                        }
                                                        onChange={
                                                            this.handleChangeInput
                                                        }
                                                    >
                                                        <option value="">
                                                            Selecciona tipo
                                                        </option>
                                                        <option value="Física">
                                                            Física
                                                        </option>
                                                        <option value="Moral">
                                                            Moral
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row ">
                                            <div className="col-6">
                                                <div className="form-group">
                                                    <label className="text-alert">
                                                        {lang.get("messages.rfc") ||
                                                            "RFC"}
                                                    </label>
                                                    <input
                                                        name="rfc"
                                                        type="text"
                                                        className={`form-control form-control-lg form-control-solid ${
                                                            this.state.country ===
                                                                1 &&
                                                            this.state
                                                                .rfcValidation &&
                                                            !this.state
                                                                .rfcValidation
                                                                .isValid
                                                                ? "is-invalid"
                                                                : ""
                                                        }`}
                                                        required
                                                        value={this.state.rfc || ""}
                                                        onChange={
                                                            this.handleChangeInput
                                                        }
                                                    />
                                                    {this.state.country === 1 &&
                                                        this.state.rfcValidation &&
                                                        !this.state.rfcValidation
                                                            .isValid && (
                                                            <div className="invalid-feedback d-block">
                                                                {this.state
                                                                    .rfcValidation
                                                                    .message ||
                                                                    "RFC inválido"}
                                                            </div>
                                                        )}
                                                </div>
                                            </div>
                                            <div className="col-6">Pais
                                                <div className="mt-4">
                                                    {this.state.country == 1 && <div>México</div>}
                                                    {this.state.country == 2 && <div>Colombia</div>}
                                                    {this.state.country == 3 && <div>Brazil</div>}
                                                    {this.state.country == 4 && <div>Otro</div>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row  ">
                                            <div className="col-6">
                                            <div className="form-group">
                                                    <label className="text-alert">
                                                        {lang.get(
                                                            "messages.estado"
                                                        )}
                                                    </label>
                                                    {this.state.country != 4 && (
                                                        <>
                                                            <select
                                                                name="estado"
                                                                className="form-control form-control-lg form-control-solid"
                                                                required
                                                                value={
                                                                    this.state
                                                                        .estado
                                                                }
                                                                onChange={
                                                                    this
                                                                        .handleChangeInput
                                                                }
                                                            >
                                                                {this.state.estadosList.map(
                                                                    (data, i) => {
                                                                        return (
                                                                            <option
                                                                                key={
                                                                                    i
                                                                                }
                                                                                value={
                                                                                    data.id
                                                                                }
                                                                            >
                                                                                {
                                                                                    data.name
                                                                                }
                                                                            </option>
                                                                        );
                                                                    }
                                                                )}
                                                            </select>
                                                        </>
                                                    )}
                                                    {this.state.country == 4 && (
                                                        <>
                                                            <input
                                                                name="custom_city"
                                                                className="form-control form-control-lg form-control-solid"
                                                                required
                                                                value={
                                                                    this.state
                                                                        .custom_city
                                                                }
                                                                onChange={
                                                                    this
                                                                        .handleChangeInput
                                                                }
                                                            />
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="form-group">
                                                    <label className="text-alert">
                                                        {lang.get(
                                                            "messages.municipio"
                                                        )}
                                                    </label>
                                                    {this.state.country != 4 && (
                                                        <>
                                                            <select
                                                                name="municipality_id"
                                                                className="form-control form-control-lg form-control-solid"
                                                                required
                                                                value={
                                                                    this.state
                                                                        .municipality_id
                                                                }
                                                                onChange={
                                                                    this
                                                                        .handleChangeInput
                                                                }
                                                            >
                                                                {this.state.municipiosList.map(
                                                                    (data, i) => {
                                                                        return (
                                                                            <option
                                                                                key={
                                                                                    i
                                                                                }
                                                                                value={
                                                                                    data.id
                                                                                }
                                                                            >
                                                                                {
                                                                                    data.name
                                                                                }
                                                                            </option>
                                                                        );
                                                                    }
                                                                )}
                                                            </select>
                                                        </>
                                                    )}
                                                    {this.state.country == 4 && (
                                                        <>
                                                            <input
                                                                name="custom_municipality"
                                                                className="form-control form-control-lg form-control-solid"
                                                                required
                                                                value={
                                                                    this.state
                                                                        .custom_municipality
                                                                }
                                                                onChange={
                                                                    this
                                                                        .handleChangeInput
                                                                }
                                                            />
                                                        </>
                                                    )}
                                                </div> 
                                            </div>
                                        </div> 
                                        <div className="row ">
                                            <div className="col-6">
                                                <div className="form-group mb-0">
                                                    <label className="text-alert">
                                                        {lang.get(
                                                            "messages.codigo_postal"
                                                        )}
                                                    </label>
                                                    <input
                                                        name="zipcode"
                                                        type="text"
                                                        className="form-control form-control-lg form-control-solid"
                                                        required
                                                        value={
                                                            this.state.zipcode
                                                        }
                                                        onChange={
                                                            this
                                                                .handleChangeInput
                                                        }
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="form-group">
                                                    <label className="text-alert">
                                                        {lang.get(
                                                            "messages.direccion"
                                                        )}
                                                    </label>
                                                    <input
                                                        name="address1"
                                                        type="text"
                                                        className="form-control form-control-lg form-control-solid"
                                                        required
                                                        value={
                                                            this.state.address1
                                                        }
                                                        onChange={
                                                            this
                                                                .handleChangeInput
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </div> 
                                    </div>
                                </div>
                            </form> 

                                                        {(this.props.uses_legacy_billing == 0 && this.props.dedicated_server == 0 )&& 
                    <>
                    <div className="row card-body  " >
                        <div className="col-md-4 text-right shadow-box   ">
                            <div className="card card-custom p-10">
                            <label className="font-weight-bolder font-size-h5 text-dark-75 text-hover-primary">Expedientes</label>
                            <div className="row">
                                <div className="col-md-12"> 
                                <div className="progress mt-3">
                                    <div
                                    className={`progress-bar ${dossiersUsagePercentage > 90 ? 'bg-danger' : 'bg-primary'}`}
                                    role="progressbar"
                                    style={{
                                    width: `${dossiersUsagePercentage}%`,
                                    }}
                                    aria-valuenow={
                                    dossiersUsagePercentage
                                    }
                                    aria-valuemin="0"
                                    aria-valuemax="100"
                                    ></div> 
                                </div>
                                <p className="text-muted font-size-h5 mt-3">{this.state.dossiers.usage}   de   {this.state.dossiers.limitation} expedientes</p> 
                                </div>
                                <div className="col-md-12">
                                    <p className="text-muted">
                                        Actualmente has creado  {this.state.dossiers.usage} expedientes de   {this.state.dossiers.limitation} 
                                    </p> 
                                    <a href="/pricing"  >Incrementar capacidad</a>
                                </div> 
                            </div>
                            </div>
                        </div>
                        <div className="col-md-4 text-right shadow-box card card-custom p-10">
                            <label className="font-weight-bolder font-size-h5 text-dark-75 text-hover-primary ">
                                Usuarios
                            </label>
                            <div className="row">
                                <div className="col-md-12"> 
                                    <div className="progress mt-3">
                                        <div
                                        className={`progress-bar ${usersUsagePercentage > 90 ? 'bg-danger' : 'bg-primary'}`}
                                        role="progressbar"
                                        style={{
                                        width: `${usersUsagePercentage}%`,
                                        }}
                                        aria-valuenow={
                                            usersUsagePercentage
                                        }
                                        aria-valuemin="0"
                                        aria-valuemax="100"
                                        ></div> 
                                    </div>
                                    <p className="text-muted font-size-h5 mt-3">{this.state.users.usage}   de   {this.state.users.limitation}   </p> 
                                </div>
                                <div className="col-md-12">
                                <p className="text-muted">
                                Actualmente tienes en uso {this.state.users.usage}  de   {this.state.users.limitation} 
                                </p> 
                                <br></br>
                                <a href="/pricing"  >Incrementar capacidad</a>
                                </div> 
                            </div>
                        </div>
                        <div className="col-md-4 text-right shadow-box">
                            <div className="card card-custom p-10">
                            <label className="font-weight-bolder font-size-h5 text-dark-75 text-hover-primary ">
                                Almacenamiento
                            </label>
                        <div className="row">
                            <div className="col-md-12"> 
                            <div className="progress mt-3">
                                <div
                                className={`progress-bar ${storageUsagePercentage > 90 ? 'bg-danger' : 'bg-primary'}`}
                                role="progressbar"
                                style={{
                                width: `${storageUsagePercentage}%`,
                                }}
                                aria-valuenow={
                                    storageUsagePercentage
                                }
                                aria-valuemin="0"
                                aria-valuemax="100"
                                ></div> 
                            </div>
                            <p className="text-muted font-size-h5 mt-3">{this.state.storage.usage}   de   {this.state.storage.limitation} GB</p> 
                            </div>
                            <div className="col-md-12">
                            <p className="text-muted">
                            Actualmente tienes en uso {this.state.storage.usage} GB de   {this.state.storage.limitation} 
                            </p>
                            
                            <br></br>
                            <a href="/pricing"  >Incrementar capacidad</a>
                            </div> 
                        </div>
                        </div>
                        </div>
                    </div>   
                    </>} 
                        </div>


                        <div className="card card-custom mt-10">
                               {canSeeConnectivityCard && canShowConnectivityModules && (
                                <div className="card card-custom  ">
                                    <div className="card-header py-5">
                                        <div className="card-title align-items-start flex-column">
                                            <h3 className="card-label font-weight-bolder text-dark">Conectividades</h3>
                                            <span className="text-muted mt-1 font-weight-bold font-size-lg">Configuración e integración de servicios conectados a la plataforma</span>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="row">
                                            {(this.props.permissions.venvers.includes("connect") || this.props.permissions.venvers.includes("all")) && (
                                                <div className="col-md-6">
                                                    <AuthVenvers personVenvers={this.state.personVenvers} />
                                                </div>
                                            )}
                                            {this.props.doc2sign_enabled === "true" && (
                                                <div className="col-md-6">
                                                    <AuthDoc2Sign />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>


                        <br />
    
                        {/* MFA Section */}
                        <TwoFactorAuth />
                        <br /> 
                        {this.props.uses_legacy_billing == 0 && (
                            <>
                                {this.state.id !== '' ? <PaymentInformation person_id={this.state.id} /> : null}
                                {this.state.id ? <HistoryPayments /> : null}
                            </>
                        )}   
                        <br></br>
                        <div className="card card-custom">
                            <div className="card-body">
                                {this.state.id ? (
                                    <CompanyUpdateRequestsHistory
                                        showwarning={false}
                                        id={this.state.id}
                                    />
                                ) : null}
                            </div>
                        </div>
                    </div>
                </div>
                <br /> 
            </>
        );
    }
}

export default AccountForm;

if (document.getElementById("AccountForm")) {
    ReactDOM.render(<AccountForm />, document.getElementById("AccountForm"));
}
